import { clientLogger } from 'UI/lib';

import gql from 'graphql-tag';

export const userSkillFragmentUpdate = (proxy, data = {}) => {
  if (!proxy || typeof data !== 'object' || Object.keys(data).length < 1) {
    return null;
  }

  try {
    const fragment = gql`
      fragment UserSkillFragment on UserSkill {
        __typename
        level
        like
        improve
        isShareable
        proofPointId
      }
    `;

    const cachedItem = `UserSkill:${data._id}`;

    proxy.writeFragment({
      id: cachedItem,
      fragment,
      data: {
        __typename: 'UserSkill',
        ...data,
      },
    });
  } catch (error) {
    clientLogger.error(
      `apolloStorage.userSkillFragmentUpdate - error caught while trying to update apollo cache - ${error.message}`,
      error
    );
  }
};

export const userSkillsFragmentUpdate = (proxy, userSkills = []) => {
  userSkills.forEach(userSkill => userSkillFragmentUpdate(proxy, userSkill));
};
